import React from "react";
import { Tooltip } from 'antd';
import "./timelineSection.scss";
import { ReactComponent as ArrowForward } from "../../../../assets/img/arrow_forward.svg";
import { ReactComponent as CheckFilled } from "../../../../assets/img/check_filled.svg";
import { ReactComponent as InfoOutline } from "../../../../assets/img/info-outline.svg";
import { APPLICATION_STATUS } from "../constants";

const STEPS = {
  [APPLICATION_STATUS.SUBMITTED]: "Application submitted",
  [APPLICATION_STATUS.IN_REVIEW]: "Application reviewed",
  [APPLICATION_STATUS.SHORTLISTED]: "Selected for interview",
  [APPLICATION_STATUS.SELECTED]: "Selected for job",
};

const TimelineSection = ({ applicationStatus, message, shouldShowTimeline }) => {
  const generateSteps = () => {
    const stepKeys = [
      APPLICATION_STATUS.SUBMITTED,
      APPLICATION_STATUS.IN_REVIEW, 
      APPLICATION_STATUS.SHORTLISTED,
      APPLICATION_STATUS.SELECTED,
    ];
  
    return stepKeys.map((stepKey, index) => {
      let label = STEPS[stepKey];
  
      if (stepKey === APPLICATION_STATUS.IN_REVIEW) {
        if (applicationStatus === APPLICATION_STATUS.IN_REVIEW) {
          label = "In Review";
        } else if (applicationStatus === APPLICATION_STATUS.REVIEW_COMPLETED) {
          label = "Review completed";
        } else if (applicationStatus === APPLICATION_STATUS.SUBMITTED) {
          label = "Pending review";
        }
      }

      if (stepKey === APPLICATION_STATUS.SELECTED) {
        if (applicationStatus === APPLICATION_STATUS.SELECTED_FOR_ANOTHER_JOB) {
          label = "Selected for another job";
        }
      }
  
      const indexOfStatus = stepKeys.findIndex(
        (status) =>
          status === applicationStatus ||
          (applicationStatus === APPLICATION_STATUS.REVIEW_COMPLETED &&
            status === APPLICATION_STATUS.IN_REVIEW) ||
          (applicationStatus === APPLICATION_STATUS.SELECTED_FOR_ANOTHER_JOB &&
            status === APPLICATION_STATUS.SELECTED)
      );
  
      let status = "upcoming";
      if (index === indexOfStatus) {
        status = "active";
      } else if (index < indexOfStatus) {
        status = "completed";
      }
  
      return {
        label,
        status,
      };
    });
  };
  
  const renderIcon = status => {
    if (status === 'completed') {
      return <CheckFilled />
    }
    if (status === 'active') {
      return <ArrowForward />
    }
    return null;
  }
  const renderTooltip = () => {
    console.log({message})
    if (!message) return null;
    return (
      <Tooltip title={message}>
        <InfoOutline width={16} height={16} />
      </Tooltip>
    )
  }

  const renderTimeline = () => {
    if (applicationStatus === APPLICATION_STATUS.ARCHIVED && message) {
      return (
        <div className="vertical-timeline">
          <p className="archived-message">{message}</p>
        </div>
      )
    }
    if (!shouldShowTimeline) return null;
    return (
      <div className="vertical-timeline">
        {generateSteps().map(({ label, status }, index) => {
          return (
            <div className="timeline-step" key={index}>
              <div className={`icon-wrapper ${status}`}>
                <div className={`icon`}>{renderIcon(status)}</div>
              </div>
              <div className={`label ${status}`}>
                {label} {status === "active" && renderTooltip()}
              </div>
              {index !== generateSteps().length - 1 && (
                <div className={`step-divider ${status}`} />
              )}
            </div>
          );
        })}
      </div>
    );
  };
  return renderTimeline();
};

export { TimelineSection };
